import { useQuery } from "@tanstack/react-query";
import { fetchJupiterQuote } from "@/lib/jupiter";
import type { JupiterQuote } from "@/types";
import { DEFAULT_SLIPPAGE_BPS } from "@/lib/utils";

interface UseJupiterQuoteOptions {
	inputMint: string;
	outputMint: string;
	amount: bigint;
	decimals: number;
	enabled?: boolean;
	slippageBps?: number;
}

export function useJupiterQuote({
	inputMint,
	outputMint,
	amount,
	enabled = true,
	slippageBps = DEFAULT_SLIPPAGE_BPS,
}: UseJupiterQuoteOptions) {
	return useQuery<JupiterQuote>({
		queryKey: ["jupiterQuote", inputMint, outputMint, amount.toString(), slippageBps],
		queryFn: () => fetchJupiterQuote(inputMint, outputMint, amount, slippageBps),
		enabled: enabled && amount > 0n && inputMint !== outputMint,
		staleTime: 15_000,
		gcTime: 60_000,
		retry: 1,
		refetchInterval: 20_000,
	});
}
